export const workHeader = {
	state: {
    workHeader: null,
	},
	mutations: {
    setWorkHeader (state, workHeader) {
      if (typeof workheader === 'object') {
        if (workHeader.hasOwnProperty('liked') 
          && workHeader.hasOwnProperty('workId')) {
            this.workHeader = workHeader
        } else {
          throw new TypeError(`payload 'workHeader' is miss property(liked or workId) [vuex]`)
        }
      } else {
        throw new TypeError(`payload is not a object[vuex]`)
      }
    },
	},
	actions: {
    
	},
	getters: {
    workHeader: state => state.workHeader
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/work-header/index.js